import { Outlet } from "react-router-dom";

export default function WebBuilderLayout() {
  return <Outlet />;
}
